import React, { useState } from "react";
import "./LeftSide.css";

const LeftSide = ({ setActiveScreen, contents, isOpen, setIsOpen }) => {
    const contentsKeys = ["top", "biography", "works", "service", "schedule", "sns", "contact"];
    const windowWidth = window.innerWidth;



    return (


        <div classNme="left-side-list-wrapper">
            <div className="left-side__list-head">
                {contents.map((contents, index) => (
                    <div
                        key={index}
                        className="left-side__list-contents hoverable"
                        onClick={() => {
                            setActiveScreen(contentsKeys[index])
                            if (windowWidth <= 991) {
                                setIsOpen(true);
                                console.log("576dayo");
                            }
                        }}

                    >
                        {contents}
                    </div>
                ))}
            </div>
        </div>



    );
}

export default LeftSide;